function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { Loading } from '@rd-web-markets/shared/dist/util';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { UserService } from '@rd-web-markets/shared/dist/services/user.service';
import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import { Col, Form, Card, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { ENGAGEMENT_TEAM_ROLES } from '../constants';
import ImmutableUnderReviewFormCheck from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewFormCheck';
import engagementTeamService from '@rd-web-markets/shared/dist/services/claim_groups/engagement_team.service';
const CreateUserAccessModal = _ref => {
  let {
    show,
    title,
    onHide,
    onSubmit,
    claimGroup
  } = _ref;
  const [clientContact, setClientContact] = useState({
    id: null,
    roles: [],
    included_in_engagement_team: false
  });
  const [claimGroupAndCompanyTeam, setClaimGroupAndCompanyTeam] = engagementTeamService.useGetEngagementTeam({
    claimGroupId: claimGroup.id
  });
  const dispatch = useDispatch();
  const roles = ENGAGEMENT_TEAM_ROLES;
  const {
    t
  } = useTranslation();
  const handleAddRole = event => {
    const roles = clientContact.roles;
    if (event.target.checked) {
      roles.push(event.target.value);
      setClientContact(_objectSpread(_objectSpread({}, clientContact), {}, {
        roles: roles,
        included_in_engagement_team: event.target.value === 'client_sponsor' ? true : clientContact.included_in_engagement_team
      }));
    } else {
      setClientContact(_objectSpread(_objectSpread({}, clientContact), {}, {
        roles: roles.filter(role => role !== event.target.value)
      }));
    }
  };
  const handleChange = (value, fieldName) => {
    setClientContact(_objectSpread(_objectSpread({}, clientContact), {}, {
      [fieldName]: value
    }));
  };
  const handleChangeIncludeEngagementTeam = event => {
    setClientContact(_objectSpread(_objectSpread({}, clientContact), {}, {
      included_in_engagement_team: event.target.checked
    }));
  };
  const clientContactModalBody = () => {
    return /*#__PURE__*/React.createElement(Card, {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Table, {
      className: "table-bordered"
    }, /*#__PURE__*/React.createElement("tbody", {
      "data-testid": "clientContactModalBody"
    }, /*#__PURE__*/React.createElement("tr", {
      className: "text-primary app-fs-table-header"
    }, /*#__PURE__*/React.createElement("th", {
      className: "border-0 font-weight-normal",
      style: {
        width: '20%'
      }
    }, t('user')), /*#__PURE__*/React.createElement("th", {
      className: "border-0 font-weight-normal",
      style: {
        width: '20%'
      }
    }, t('role')), /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormCheck, {
      value: clientContact.included_in_engagement_team,
      label: t('engagement_team'),
      checked: clientContact.included_in_engagement_team,
      name: "included_in_engagement_team",
      onChange: e => handleChangeIncludeEngagementTeam(e)
    }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
      as: Select,
      onChange: e => handleChange(e.value, 'user_id'),
      options: claimGroupAndCompanyTeam.company_users_not_added_to_claim_group.map(u => {
        return {
          value: u.user_id,
          label: "".concat(u.name, " ").concat(u.email)
        };
      }),
      size: "md",
      className: "p-0 border-0",
      styles: {
        control: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
          borderColor: '#80bbdc'
        })
      }
    })), /*#__PURE__*/React.createElement("td", {
      style: {
        width: '20%'
      }
    }, roles.map(role => {
      return /*#__PURE__*/React.createElement(Form.Check, {
        checked: clientContact.roles.includes(role.value),
        value: role.value,
        name: role.value,
        label: t(role.value),
        onChange: e => handleAddRole(e)
      });
    })))))));
  };
  if (!claimGroupAndCompanyTeam) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: t(title),
    show: show,
    renderBody: () => clientContactModalBody(),
    onHide: onHide,
    onSubmit: () => onSubmit(clientContact)
  }));
};
export default CreateUserAccessModal;